import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import serviceData from './../data/serviceData.json';
import { Link } from 'react-router-dom';

const OurService = () => {
  return (
    <>
      {/* Our Services Section Start */}
      <div className="our-services">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h3 className="wow fadeInUp">our services</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Innovative design services for <span>every need</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-title-content">
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  We offer a range of bespoke interior design services tailored to
                  your unique needs. From concept development to final installation.
                </p>
              </div>
            </div>
          </div>

          {/* Swiper Service Slider */}
          <Swiper
            className="serviceSlider"
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false
            }}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              768: {
                slidesPerView: 2
              },
              992: {
                slidesPerView: 3
              }
            }}
            modules={[Autoplay]}
          >
            {serviceData.map((service, index) => (
              <SwiperSlide key={index}>
                <div className="service-item wow fadeInUp" data-wow-delay={`${index * 0.2}s`}>
                  <div className="service-image">
                    <a href={service.link} data-cursor-text="View">
                      <figure className="image-anime">
                        <img src={service.image} alt={service.title} />
                      </figure>
                    </a>
                  </div>
                  <div className="service-btn">
                    <a href={service.link}>
                      <img src="images/arrow-white.svg" alt="arrow" />
                    </a>
                  </div>
                  <div className="service-content">
                    <h3>
                      <a href={service.link}>{service.title}</a>
                    </h3>
                    <p>{service.info}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* See All Services Button */}
          <div className="row">
            <div className="col-lg-12">
              <div className="all-services-btn wow fadeInUp" data-wow-delay="0.6s">
                <Link to="/services" className="btn-default">
                  see all services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Services Section End */}
    </>
  );
};

export default OurService;
